import { jsx as e } from "react/jsx-runtime";
//#region src/components/applicationHeader/ApplicationActionBar.tsx
var t = (t) => {
	let { items: n, nodeRef: r, className: i = "", ...a } = t;
	return /* @__PURE__ */ e("ul", {
		...a,
		className: `ApplicationActionBar nav navbar-nav navbar-right ${i}`,
		ref: r,
		children: n?.map((t, n) => /* @__PURE__ */ e("li", {
			role: "presentation",
			className: "navigationItem",
			children: t
		}, n))
	});
};
//#endregion
export { t as default };

//# sourceMappingURL=ApplicationActionBar.js.map